import * as _ from 'lodash';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PromotionService, CntryBannerItemModel } from '../../../services/index';

@Component({
  selector: 'account-selector',
  templateUrl: 'account-selector.html'
})
export class AccountSelectorComponent {
  @Input() selectedCntryCd: string;
  @Input() disabled: boolean = false;
  @Output() onAccountSelect: EventEmitter<CntryBannerItemModel> = new EventEmitter();

  selectedAccount: CntryBannerItemModel;
  accountList: Array<CntryBannerItemModel> = [];  
  isCntryListOpen:boolean = false;
  filteredCountryList: Array<CntryBannerItemModel> = [];
  focusedCntryIndex: number;


  @ViewChild("countryList")
  countryListElRef: ElementRef;

  countryControl: FormControl  = new FormControl();

  constructor(
    private promotionService: PromotionService,
  ) {
    
  }

  ngOnInit() {
    this.accountList = this.promotionService.accountList;
    
    if(_.isEmpty(this.accountList)) {
      this.promotionService.accountListEe.subscribe(accountList => {
        this.accountList = accountList;
        this.checkInputCntry();
      });
    } else {
      this.checkInputCntry();
    }
  }

  checkInputCntry() {
    if(this.selectedCntryCd != null) {
      this.selectedAccount = _.find(this.accountList, {countryCode : this.selectedCntryCd});
      if(this.selectedAccount) this.countryControl.setValue(this.selectedAccount.countryName);
    };
  }

  setFilteredCountryList(event) {
    if (!event) return;
    
    let keyword = event.target.value;
    if (!keyword) {
      if (this.selectedAccount) this.selectedAccount = null;
      this.onAccountSelect.emit(null);
      this.isCntryListOpen = false;
      return;
    }

    if(keyword.length > 0) {
      keyword = _.toUpper(keyword.trim()).replace(/\s/g, '');

		  let filteredCountryList = _.map(_.filter(this.accountList,
																	(account) => {
                                    if(account.countryName != null && account.countryCode != null) {
                                      if (keyword.length <= 0) return true;
                                      else if (_.toUpper(account.countryName.trim()).replace(/\s/g, '').indexOf(keyword) >= 0) return true;
                                      else if (_.upperCase(account.countryCode).indexOf(keyword) >= 0) return true;
                                      else return false;
                                    } else {
                                      return false;
                                    };
                                  }));
      
      this.filteredCountryList = _.sortBy(filteredCountryList,
																(account) => {
																	let nmIndex = _.toUpper(account.countryName.trim()).replace(/\s/g, '').indexOf(keyword);
																	let cdIndex = _.upperCase(account.countryCode).indexOf(keyword);
																	if (nmIndex < 0) nmIndex = 999;
																	if (cdIndex < 0) cdIndex = 999;
																	return _.min([nmIndex, cdIndex])
																});

      this.isCntryListOpen = true;
      this.focusedCntryIndex =  0;    
    } else {
      this.isCntryListOpen = false;
    }
  }

  handleKeyDown(event) {
    if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;

		let suggestListDom = null;
		let focusedIndex = null;
		let type = null;

    suggestListDom = this.countryListElRef.nativeElement;
    focusedIndex = this.focusedCntryIndex;
    
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');


		switch (event.keyCode) {
			case 13: // enter
        if (_.isEmpty(this.filteredCountryList) || !this.focusedCntryIndex == null || !this.isCntryListOpen) return;
        let item = this.filteredCountryList[this.focusedCntryIndex];
        this.cntryListSelectHandler(item);
        this.isCntryListOpen = false;
			  break;
			case 27: // escape
					this.isCntryListOpen = false;
          
          if (this.selectedAccount) this.countryControl.setValue(this.selectedAccount.countryName);
          
			  break;
			case 38: // up
        focusedIndex--;
        if (focusedIndex < 0) focusedIndex = 0;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > suggestListItem.length - 1) focusedIndex = suggestListItem.length - 1;
        suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
        break;
			default: return;
    }	
    if (focusedIndex != this.focusedCntryIndex) this.focusedCntryIndex = focusedIndex;
    event.preventDefault();
  }

  handleCntryBlur($event) {
    if (this.isCntryListOpen) this.isCntryListOpen = false;

    if (this.selectedAccount && $event.target.value) {
      this.countryControl.setValue(this.selectedAccount.countryName);
    } else {
      this.countryControl.setValue(null);
    }
  }

  cntryListSelectHandler(cntry) {
    this.isCntryListOpen = false;
    this.selectedAccount = cntry;
    
    if(this.selectedAccount != null) {
      this.countryControl.setValue(this.selectedAccount.countryName);
      this.onAccountSelect.emit(this.selectedAccount);
    }  
    
  }

  


}


// WEBPACK FOOTER //
// ./src/app/containers/promotion/contract/account-selector.ts